// @ts-nocheck
import imageCompression from 'browser-image-compression';

export const isHeic = (file: File) => /heic$/i.test(file.name) || file.type === 'image/heic' || file.type === 'image/heif';

export async function convertHeicToJpeg(file: File): Promise<File> {
  try {
    const { default: heic2any } = await import('heic2any');
    const blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 });
    const jpgName = file.name.replace(/\.heic$/i, '.jpg');
    return new File([blob as BlobPart], jpgName, { type: 'image/jpeg' });
  } catch (e) {
    // If conversion fails, return original so user can still upload
    return file;
  }
}

export async function compressImage(file: File, maxSizeMB = 100): Promise<File> {
  // Compress if larger than desired target while staying within 100MB limit
  const options = {
    maxSizeMB: Math.min(maxSizeMB, 100),
    maxWidthOrHeight: 4096,
    useWebWorker: true,
    initialQuality: 0.9,
  } as any;
  try {
    const compressed = await imageCompression(file, options);
    return compressed as File;
  } catch {
    return file;
  }
}

export const validateImageFile = (file: File) => {
  const isImage = file.type.startsWith('image/') || /\.heic$/i.test(file.name);
  const ok = isImage && file.size <= 100 * 1024 * 1024; // 100MB
  return ok;
};
